import React, { useContext } from 'react';
import { ThemeContext } from './context/ThemeContext';
import Navbar from './components/Navbar';
import { Route, Routes, useLocation, Navigate } from 'react-router-dom';
import Home from './pages/Home';
import Dashboard from './pages/Dashboard';
import Demo from "./pages/Demo";
import MobileNavbar from "./components/mobileNavbar";

const App = () => {
    const { isDarkMode } = useContext(ThemeContext);
    const location = useLocation();

    const basePath = "/j9vUzpr9Vqrfs75lDr8qAdHcgMPgKn6Q";
    const mobileDemoPath = `${basePath}/mobile-demo`;

    if (!location.pathname.startsWith(basePath)) {
        return <>Unauthorized</>;
    }

    const isMobileDemo = location.pathname.startsWith(mobileDemoPath);

    return (
        <>
            {!isMobileDemo && <Navbar />}
            {isMobileDemo && <MobileNavbar />}

            <Routes>
                <Route path={`${basePath}`} element={<Home />} />
                <Route path={`${basePath}/dashboard`} element={<Dashboard />} />
                <Route path={`${basePath}/demo`} element={<Demo />} />
                <Route path={`${mobileDemoPath}`} element={<Demo />} />
                <Route path="*" element={<Navigate to={basePath} />} />
            </Routes>
        </>
    );
};

export default App;
